import React from 'react';
import DetailLayout from '../../../../Components/Layout/DetailLayout';
import {useParams} from 'react-router-dom';
import useRequest from '../../../../Utils/Hooks/useRequest';
import {getTenantService} from '../service';
import {Card, Col, Dropdown, Empty, Row, Skeleton} from 'antd';
import Style from './index.module.scss';
import {SettingOutlined} from '@ant-design/icons';
import useModalHandler from '../../../../Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import MenuModal from './Components/MenuModal';
import {isEmpty} from '../../../../Stores/commonStore';
import CurrentTenant from '../../CurrentTenant';
const Index = () => {
    const {id} = useParams<{id: string}>();
    const [data, , reload] = useRequest(() => getTenantService(id!));
    const editModal = useModalHandler({component: EditModal});
    const menuModal = useModalHandler({component: MenuModal});

    function onEditOk() {
        editModal.close();
        menuModal.close();
        reload();
    }

    if (!id) {
        return null;
    }

    return (
        <DetailLayout>
            {id && <CurrentTenant id={id} />}
            {!data && <Skeleton paragraph={{rows: 15}} />}
            {data && (
                <div className={Style.root}>
                    <DetailLayout.Title>已开通服务</DetailLayout.Title>
                    <Row gutter={[15, 12]} style={{marginBottom: 40}}>
                        {data.orderList.map(item => (
                            <Col xl={6} md={12} sm={24} key={item.id}>
                                <Card
                                    extra={
                                        <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        label: '详情',
                                                        key: 'detail',
                                                        onClick: () => {
                                                            editModal.open({
                                                                serviceDetailId:
                                                                    item.id,
                                                                customerId: id,
                                                                onOk: onEditOk,
                                                            });
                                                        },
                                                    },
                                                    {
                                                        label: '菜单设置',
                                                        key: 'setting',
                                                        onClick: () => {
                                                            menuModal.open({
                                                                serviceDetailId:
                                                                    item.id,
                                                                customerId: id,
                                                                onOk: onEditOk,
                                                            });
                                                        },
                                                    },
                                                ],
                                            }}>
                                            <SettingOutlined
                                                className={Style.setting}
                                            />
                                        </Dropdown>
                                    }
                                    title={
                                        <div className={Style.title}>
                                            {item.name}
                                        </div>
                                    }>
                                    <ul>
                                        <li className={Style.list}>
                                            <span>用户上限：</span>
                                            {item.maxUserNumber} 人
                                        </li>
                                        <li className={Style.list}>
                                            <span>开通日期：</span>
                                            {item.expirationStartTime}
                                        </li>
                                        <li className={Style.list}>
                                            <span>失效日期：</span>
                                            {item.expirationEndTime}
                                        </li>
                                    </ul>
                                </Card>
                            </Col>
                        ))}
                        {isEmpty(data.orderList) && (
                            <div className={Style.empty}>
                                <Empty />
                            </div>
                        )}
                    </Row>
                    <DetailLayout.Title>未开通服务</DetailLayout.Title>
                    <Row gutter={[15, 12]}>
                        {data.otherList.map(item => (
                            <Col xl={6} md={12} sm={24} key={item.id}>
                                <Card
                                    title={
                                        <div className={Style.title}>
                                            {item.name}
                                        </div>
                                    }>
                                    <Empty />
                                </Card>
                            </Col>
                        ))}
                        {isEmpty(data.otherList) && (
                            <div className={Style.empty}>
                                <Empty />
                            </div>
                        )}
                    </Row>
                </div>
            )}

            {editModal.render()}
            {menuModal.render()}
        </DetailLayout>
    );
};

export default Index;
